<template>
    <div class="pb-3 mb-3 md:pt-2 md:pb-5 md:mb-3 border-b border-dashed">
        <div class="flex">
            <div class="w-4/5 xs:text-lg flex items-center mr-3">
                <p>{{ `${item.fundCode} ${item.fundName}` }}</p>
            </div>
            <div class="flex justify-end md:justify-start md:w-1/5 pt-0 md:pt-0 flex-shrink-0">
                <div class="w-[4.5rem] md:w-auto">
                    <div class="flex items-center">
                        <input
                            v-model.trim="item.percent"
                            inputmode="numeric"
                            autocomplete="off"
                            class="input-base pr-6"
                            :disabled="item.disabledPercent"
                            maxlength="3"
                            @input="$emit('validatePercent',index)"
                        >
                        <SvgIcon
                            icon-name="percent"
                            :class="{'text-gray-200':item.disabledPercent}"
                            class=" w-5 h-5 -ml-6"
                        />
                    </div>
                    <p class="error-msg text-right md:-mb-4">
                        {{ item.errorMessage.percent }}
                    </p>
                </div>
                <button
                    class="w-11 h-11 xs:w-12 xs:h-12 flex justify-center items-center rounded ring-1 ring-gray-100 ml-3 flex-shrink-0"
                    :class="arrayLength===1?'bg-gray-75':'bg-white'"
                    :disabled="arrayLength===1"
                    @click="arrayLength===1?'':$emit('openPopup',index)"
                >
                    <SvgIcon
                        icon-name="delete_forever"
                        class=" w-6 h-6 xs:w-8 xs:h-8"
                        :class="arrayLength===1?'text-gray-200':'text-gray-700'"
                    />
                </button>
            </div>
        </div>
        <div
            v-if="item.fundMsg.length>0"
            class="mt-1.5 md:mt-2.5 w-full bg-gray-50 px-2.5 py-1.5 md:py-2.5 text-warning text-sm xs:text-base"
        >
            {{ item.fundMsg }}
        </div>
    </div>
</template>

<script>
import { toRef } from 'vue';

export default {
    props: {
        arrayLength: {
            type: Number,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
    },
    emits: ['validatePercent', 'openPopup'],
    setup(props) {
        const item = toRef(props, 'data');
        return { item };
    },
};
</script>
